import React from 'react';
import {View} from 'react-native';
import {IStateProps} from './model';
import {Field} from 'redux-form';
import {CheckboxField} from './components/checkboxField';
import {Text} from '../../../../../shared/components/text';
import {getProfileApplicationsAndDocumentsFilterName} from '../../../common/filter';
import {dictionaryPipe} from '../../../../../shared/pipes/dictionary';
import {useStyles} from '../../../../../shared/hooks/styles';
import {capitalize} from '../../../../../shared/utils/text';

export default ({typeApplicationDictionary, statusDictionary}: IStateProps) => {
  const styles = useStyles(({theme}) => ({
    container: {
      paddingTop: 12,
    },
    item: {
      marginBottom: 10,
    },
    group: {
      paddingVertical: 12,
      paddingHorizontal: 20,
    },
    groupFields: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    groupControls: {
      marginLeft: 30,
      flexGrow: 1,
      flexShrink: 1,
    },
    groupButton: {
      alignItems: 'center',
    },
    groupBorderTop: {
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    groupTitle: {
      ...theme.fonts.h5Light,
      marginBottom: 10,
      width: 270,
    },
    label: {
      ...theme.fonts.body,
    },
    button: {
      width: 200,
    },
  }));
  return (
    <View style={[styles.container]}>
      <View style={[styles.group, styles.groupFields]}>
        <Text style={styles.groupTitle}>Тип заявления</Text>
        <View style={styles.groupControls}>
          {Object.keys(typeApplicationDictionary).map((key) => (
            <View key={key} style={[styles.item]}>
              <Field
                component={CheckboxField}
                type='checkbox'
                name={getProfileApplicationsAndDocumentsFilterName(key, 'typeApplication')}
                label={capitalize(dictionaryPipe(key, typeApplicationDictionary))}
                labelStyle={styles.label}
              />
            </View>
          ))}
        </View>
      </View>
      <View style={[styles.group, styles.groupFields, styles.groupBorderTop]}>
        <Text style={styles.groupTitle}>Статус заявления</Text>
        <View style={styles.groupControls}>
          {Object.keys(statusDictionary).map((key) => (
            <View key={key} style={[styles.item]}>
              <Field
                component={CheckboxField}
                type='checkbox'
                name={getProfileApplicationsAndDocumentsFilterName(key, 'status')}
                label={dictionaryPipe(key, statusDictionary)}
                labelStyle={styles.label}
              />
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};
